import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

const initialState = {
    isLoading: false,
    error: null,
    success: false,
    pinnedMessage: null,
    publics: [],
};

const slice = createSlice({
    name: 'bot',
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        stopLoading(state) {
            state.isLoading = false;
        },
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
            state.success = false;
        },
        pinMessageSuccess(state) {
            state.isLoading = false;
            state.success = true;
        },
        getPinnedMessageSuccess(state, action) {
            state.isLoading = false;
            state.pinnedMessage = action.payload;
        },
        getPublicsSuccess(state, action) {
            state.isLoading = false;
            state.publics = action.payload;
        },
        resetStatus(state) {
            state.isLoading = false;
            state.error = null;
            state.success = false;
        },
    },
});

// Reducer
export default slice.reducer;

// Actions
export const { resetStatus } = slice.actions;

// ----------------------------------------------------------------------

export function pinChannelMessage(shopid, data) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.post(`/editbot/${shopid}/pinv`, data);

            if (response.data.success === false) {
                dispatch(slice.actions.hasError(response.data.data || 'Failed to pin message'));
                return false;
            }

            dispatch(slice.actions.pinMessageSuccess());
            return true;
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            return false;
        }
    };
}

export function getPinnedMessage(shopid) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get(`/editbot/${shopid}/pinv`);

            if (response.data.success) {
                dispatch(slice.actions.getPinnedMessageSuccess(response.data.data));
                return response.data.data;
            }
            dispatch(slice.actions.stopLoading());
            return null;
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            return null;
        }
    };
}

export function getPublics(shopid) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get(`/editbot/${shopid}/pinv/publics`);

            if (response.data.success) {
                dispatch(slice.actions.getPublicsSuccess(response.data.data));
                return response.data.data;
            }
            dispatch(slice.actions.stopLoading());
            return [];
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            return [];
        }
    };
}

export function sendPinnedMessageToPublic(shopid, data) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.post(`/editbot/${shopid}/pinv/publics/send`, data);

            if (response.data.success === false) {
                dispatch(slice.actions.hasError(response.data.data || 'Failed to send message'));
                return false;
            }

            dispatch(slice.actions.stopLoading());
            return true;
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            return false;
        }
    };
}
